import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";
import RoutesMap from "../../../../route_control/RouteControl"

export const subCategoryByCategoryTodo = createAsyncThunk('subCategoryByCategory', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `subcategory_by_cat/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const subCategoryByCategorySlice = createSlice({
    name: 'subCategoryByCategory',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(subCategoryByCategoryTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(subCategoryByCategoryTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default subCategoryByCategorySlice.reducer; 